import { Component, EventEmitter, Output } from "@angular/core";

/**
 * "Leave this page?" confirmation.
 * Design reference: docs/AI/leave the screen.png
 *
 * Shown when the user tries to close the wizard or exit MAIA while an uploaded
 * SOV would be lost — the confirmation rule from the developer handoff.
 */
@Component({
    selector: "maia-leave-dialog",
    templateUrl: "./maia-leave-dialog.component.html",
    styleUrls: ["./maia-leave-dialog.component.scss"],
})
export class MaiaLeaveDialogComponent {
    /** Dismiss — the user stays where they are. */
    @Output() readonly stay = new EventEmitter<void>();

    /** Proceed — discard progress and leave. */
    @Output() readonly leave = new EventEmitter<void>();
}
